/**
 * Design utilities for UI components and styling
 * @module design
 */
export {
  cx,
  cn,
  focusInput,
  focusRing,
  hasErrorInput,
  shouldShowInteractiveGlobe,  
} from './design'

/**
 * Text and number formatting utilities
 * @module formatters
 */
export {
  formatText,
  formatTitleCase,
  formatPercent,
  formatRatio,
  formatNumber,
  formatCurrency,
  formatCompact,
  formatDuration,
  formatNumberForDisplay,
  escapeHtml,
  formatOrdinal
} from './formatters'

/**
 * Date manipulation and formatting utilities
 * @module date
 */
export {
  formatDate,
  formatDateISO,
  formatDateTime,
  formatRelativeDate,
  formatSortableDate,
  compareDates,
  getDaysSince,
  isValidDate,
  parseDate,
  getStartOfDay,
  getEndOfDay
} from './date'

/**
 * Event handling and DOM interaction utilities
 * @module events
 */
export {
  addPassiveEventListener,
  usePassiveScroll,
  useWindowResize,
  usePassiveTouch,
  usePassiveClickOutside,
  useResizeObserver,
  useIntersectionObserver,
  useKeyPress,
  debounce
} from './events'
